import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Nextractor= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={5} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
              Automated DNA/RNA Extractor  
                <br />
                <Typography component="span" variant="inherit" color="primary">
                NEXTRACTOR
                </Typography>
              </span>
            }
            subtitle="NX-48S is a high throughput Fully Automated RNA and DNA extraction system"
            align="left"
            disableGutter
            titleVariant="h3"
            />
            <ul>
              
              <li>  High throughput:  48 samples in single run in about 15~20min  </li>

              <li>CE/IVD, US-FDA approved </li>

              <li>Principle of extraction is based on using magnetic beads  </li>

              <li>Pre- filled cartridge design ( 1/ 8/ 24 samples) </li>

              <li>Pre-programmed and user defined protocol </li>

              <li>Built-in Heating block  </li>

              <li>Plug-in play model  </li>

              <li>Compact / Light Weight 25kg – Size (cm) 36.4 x 38.6 x 42 </li>

              <li>7-inch Touchscreen with pre-programmed & user defined protocols </li>

              <li>Door lock and UV sterilization. </li>

              <li>Heating upto 120 Deg Celsius "</li>

</ul>

<SectionHeader
            ctaGroup={[
              <Button variant="contained" color="primary" size="large">
             Quickbook
              </Button>,
              <Button variant="outlined" color="primary" size="large">
              Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://onwhicar.sirv.com/premas/main/genolution/Untitled.png"
            alt="nextractor"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Nextractor.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Nextractor;
